import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * A simple service to track the loading status of widgets on the current dashboard.
 * Used to drive UI behaviour (e.g. prevent actions while widgets are still loading.)
 */
@Injectable({
    providedIn: 'root',
})
export class DashboardWidgetLoadingService {
    private _widgetsLoading: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

    public readonly widgetsLoading$: Observable<string[]>;

    constructor() {
        this.widgetsLoading$ = this._widgetsLoading.asObservable();
    }

    /**
     * Add a widget ID to the list of widgets currently loading.
     * @param id The ID of the widget.
     */
    public add(id: string): void {
        const currentIds = this._widgetsLoading.getValue();

        if (currentIds.includes(id)) {
            return;
        }

        const newIds = [...currentIds, id];

        this._widgetsLoading.next(newIds);
    }

    /**
     * Remove a widget ID from the list of widgets currently loading.
     * @param idLoaded The ID of the widget.
     */
    public remove(idLoaded: string): void {
        const currentIds = this._widgetsLoading.getValue();
        const newIds = currentIds.filter((id) => id !== idLoaded);

        this._widgetsLoading.next(newIds);
    }

    /**
     * Clear all widget IDs from the list of widgets currently loading.
     */
    public removeAll(): void {
        this._widgetsLoading.next([]);
    }
}